const DATE_TIME_FORMATS = (() => {
  let locale;
  try {
    locale = JSON.parse(localStorage.getItem('troveDateTimeLocale')) || ['en-US'];
  } catch (error) {
    localStorage.removeItem('troveDateTimeLocale');
    locale = ['en-US'];
  }

  /**
   * Globally set the locale used by all `Intl.DateTimeFormat` that `DATE_TIME_FORMATS` exposes. You
   * can call this at any time to change the global locale.
   * @param {string | string[]} newLocale The new locale as a single BCP 47 language tag or an array
   * of BCP 47 language tags
   */
  const setLocale = (newLocale) => {
    const newLocaleArray = Array.isArray(newLocale) ? newLocale : [newLocale];
    const newLocaleArrayJson = JSON.stringify(newLocaleArray);
    // Compare as JSON in case newLocale is equivalent to the current locale. For performance, we
    // only check strict equality in getFormat below, so this check avoids invalidating currently
    // constructed formats for no-op setLocale calls.
    if (newLocaleArrayJson !== JSON.stringify(locale)) {
      locale = newLocaleArray;
      localStorage.setItem('troveDateTimeLocale', newLocaleArrayJson);
    }
  };

  const FORMAT_CACHE = new Map();

  const getFormat = (formatId, options) => {
    const cached = FORMAT_CACHE.get(formatId);
    if (cached?.locale === locale) {
      return cached.format;
    }
    const format = new Intl.DateTimeFormat(locale, options);
    FORMAT_CACHE.set(formatId, { locale, format });
    return format;
  };

  return {
    setLocale,

    /**
     * An `Intl.DateTimeFormat` instance that produces a date string (without time) with...
     * - 4-digit year
     * - Numeric month, padded to 2 digits
     * - Day of month padded to 2 digits
     *
     * In the default en-US locale, this is equivalent to MM/DD/YYYY.
     *
     * This format is computed from the current locale. Do **not** store this format in a variable
     * for long duration. Instead, access this format from `DATE_TIME_FORMATS` each time you use it.
     * E.g.
     * ```
     * DATE_TIME_FORMATS.PADDED_NUMERIC_DATE.format(new Date(someISO8601DateString))
     * ```
     */
    get PADDED_NUMERIC_DATE() {
      return getFormat(
        'PADDED_NUMERIC_DATE',
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
      );
    },
  };
})();
